import React, {Fragment} from 'react';
import {DraggableEventHandler} from 'react-draggable';

import {ZERO_TO_FOUR} from '#Client/components/constants';
import {
  draggingCell,
  droppingCell,
  gridCell,
  gridCellFixed,
  gridCellSelected,
  gridCheck,
  gridCheckBottom,
  gridContainer,
  gridSpacer,
  gridSpacerBottom,
} from '#Client/components/Grid/Grid.css';
import {Letter} from '#Client/components/Letter/Letter';
import {Check} from '#Client/images/Check';

type GridProps = {
  fixedCells: Record<string, string>;
  grid: Record<string, string>;
  selectedCell: number[];
  selectCell: (coordinates: number[]) => void;
  validation: string[];
  getOnStart: (row: number, column: number, letter: string) => () => void;
  onDragStop: () => void;
  onDrag: DraggableEventHandler;
  droppingCoordinates: number[];
  draggedFromCoordinates: number[];
  victorious: boolean;
  setLookupWord: (index: number) => void;
};

export const Grid = ({
  fixedCells,
  grid,
  selectedCell,
  selectCell,
  validation,
  getOnStart,
  onDragStop,
  onDrag,
  droppingCoordinates,
  draggedFromCoordinates,
  victorious,
  setLookupWord,
}: GridProps) => {
  const gridIsDropping =
    droppingCoordinates[0] !== -1 && droppingCoordinates[1] !== -1;
  return (
    <div className={`${gridContainer}`}>
      {ZERO_TO_FOUR.map((rowIndex: number) => (
        <Fragment key={rowIndex}>
          {ZERO_TO_FOUR.map((columnIndex: number) => {
            const letter = grid[`${rowIndex}-${columnIndex}`];
            const isFixed = `${rowIndex}-${columnIndex}` in fixedCells;
            const isSelected =
              (rowIndex === selectedCell[0] &&
                columnIndex === selectedCell[1]) ||
              (rowIndex === selectedCell[1] && columnIndex === selectedCell[0]);
            const isDropping =
              (rowIndex === droppingCoordinates[0] &&
                columnIndex === droppingCoordinates[1]) ||
              (rowIndex === droppingCoordinates[1] &&
                columnIndex === droppingCoordinates[0]);
            const isDragging =
              rowIndex === draggedFromCoordinates[0] &&
              columnIndex === draggedFromCoordinates[1];
            return (
              <div
                className={`${gridCell} ${isFixed ? gridCellFixed : ''} ${
                  isSelected && !victorious && !gridIsDropping
                    ? gridCellSelected
                    : ''
                } ${isDropping ? droppingCell : ''} ${
                  isDragging ? draggingCell : ''
                }`}
                data-columnindex={columnIndex}
                data-rowindex={rowIndex}
                key={`${rowIndex}-${columnIndex}`}
                onClick={() => {
                  if (letter === '') {
                    selectCell([rowIndex, columnIndex]);
                  }
                }}
              >
                {letter === '' ? (
                  <span></span>
                ) : (
                  <Letter
                    draggable={!victorious && !isFixed}
                    gridColumn={columnIndex}
                    gridRow={rowIndex}
                    letter={letter}
                    onDrag={onDrag}
                    onStart={getOnStart(rowIndex, columnIndex, letter)}
                    onStop={onDragStop}
                  />
                )}
              </div>
            );
          })}
          <div className={gridSpacer}>
            {validation[rowIndex] === 'y' && (
              <Check
                className={gridCheck}
                onClick={() => {
                  setLookupWord(rowIndex);
                }}
              />
            )}
          </div>
        </Fragment>
      ))}
      {ZERO_TO_FOUR.map((columnIndex: number) => {
        return (
          <div className={gridSpacerBottom} key={columnIndex}>
            {validation[columnIndex] === 'y' && (
              <Check
                className={gridCheckBottom}
                onClick={() => {
                  setLookupWord(columnIndex);
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};
